export { default } from './CashClosing'; 